import { loadIndividualForm } from '../api/individual-form.api';
export default class IndividualFormService {
    constructor(dataProvider) {
        this._dataProvider = dataProvider;
    }
    async load(activityId) {
        const data = await loadIndividualForm(activityId, this._dataProvider.branchId);
        this._dataProvider.individualForms = data;
    }
}
